export class PlaybooksLinkUrl {

    constructor(json: any = null) {
        if (json) {
            Object.assign(this, json);
        }
    }

    name: string;
    description: string;
    url: string;
}

export class PlaybooksLinkUrls {

    constructor(json: any = null) {
        if (json) {
            Object.assign(this, json);
        }
    }

    alert: string;
    applicationLog: string;
    dashboard: string;
    documents: string;
    nome: string;
    inventory: string;
    records: string;
    reports: string;
}
